module.exports = __webpack_public_path__ + "img/lock-big.279e1465.svg";